export const InventoryEventLogSymbol = Symbol('inventoryEventLog');
